import { Heading } from '../../components';

import css from './ListingPage.module.css';

const SectionCancellationPolicy = props => {
  const { listing, intl } = props;

  return (
    <div className={css.sectionProfile}>
      <section className={css.sectionText}>
        <Heading as="h2" rootClassName={css.sectionHeading}>
          Cancellation Policy
        </Heading>
        <div className={css.lightText}>
          <h3 className={css.subheader}>Notice Requirements</h3>
          <p className={css.body_w_subheader}>
            Cancellations must be made at least 7 days prior to the scheduled service start date to receive a full refund. Cancellations must be made on the booking platform by clicking the "Cancel Booking" button. Verbal or written cancellations will not be accepted. If you don't see the button displayed, you're within the cancellation period.
          </p>

          <h3 className={css.subheader}>Standard Cancellations</h3>
              <ul className={css.bulletList}>
                <li>7+ days notice: Full refund</li>
                <li>Less than 7 days' notice: No refund</li>
              </ul>


          <h3 className={css.subheader}>Holiday Cancellations</h3>
          <p className={css.body_w_subheader}>For services scheduled during major holidays (Thanksgiving, Christmas, New Year's, etc.):</p>
          <ul className={css.bulletList}>
            <li>14+ days notice: Full refund</li>
            <li>Less than 14 days' notice: No refund</li>
          </ul>

          <p className={css.lightText}>
            <strong>Refund Policy:</strong> Refunds for eligible cancellations will be processed within 5-7 business days to the original payment method.
          </p>
          <h3 className={css.subheader}>Right to Refuse Service</h3>
          <p className={css.body_w_subheader}>
            We reserve the right to cancel services if pets pose a safety risk, if home conditions are unsuitable or unsafe, or if payment is not received. In such cases, appropriate notice will be provided when possible.
          </p>
        </div>
      </section>

    </div>
  );
};

export default SectionCancellationPolicy;
